import { render, staticRenderFns } from "./periodos-lectivos.vue?vue&type=template&id=f7ff9a10&scoped=true&"
import script from "./periodos-lectivos.component.ts?vue&type=script&lang=ts&"
export * from "./periodos-lectivos.component.ts?vue&type=script&lang=ts&"
import style0 from "./periodos-lectivos.vue?vue&type=style&index=0&id=f7ff9a10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ff9a10",
  null
  
)

export default component.exports